import React, { useState } from 'react';
import { useToast } from '../ToastManager';
import { statusDef, formatOrderDate, normalizeSalesChannel } from '../../utils/orderUtils';
import PageHeader from '../ui/PageHeader';
import StatusBadge from '../ui/StatusBadge';
import ChannelBadge from '../ui/ChannelBadge';
import Button from '../ui/Button';
import { OrderEditForm } from '../OrderEditModal';
import { customerName } from './OrderListInspector';

/* Página de edición de pedido (F3.5) — movida verbatim de OrdersPage a un lugar
   compartido (F5 Tema 3): la consumen Pedidos Y Resumen (Opción A: Resumen la
   embebe manteniendo su lista montada-oculta → "Volver" conserva período/filtros,
   criterio 17). Es la ÚNICA superficie de edición. */
export default function OrderEditPage({ order, onBack, onListChanged }) {
  const { showToast } = useToast();
  const [editControls, setEditControls] = useState(null); // Guardar/estado del form embebido
  const d = statusDef(order.status);

  return (
    <div className="orders-page page-shell op-fullview">
      {/* Flecha destacada (F3.5: las migas no gustaron — vuelve la flecha,
         más visible) */}
      <div>
        <button type="button" className="op-fv-back" onClick={onBack}>← Volver a pedidos</button>
      </div>
      <PageHeader
        title={`Editar pedido #${order.number}`}
        description={`${formatOrderDate(order.date_created)} · ${customerName(order)}`}
        metadata={<span className="op-fv-badges">
          <StatusBadge variant={d.variant}>{d.label}</StatusBadge>
          <ChannelBadge channel={normalizeSalesChannel(order).key} />
        </span>}
        primaryAction={<Button variant="primary" loading={editControls?.saving} disabled={!editControls?.canSave} onClick={() => editControls?.save()}>Guardar cambios</Button>}
        secondaryActions={<Button onClick={onBack} disabled={editControls?.saving}>Cancelar</Button>}
      />

      {/* La MISMA columna legible de 760px del inspector-en-grande, en el
         orden canónico (principio de las tres superficies) */}
      <div className="op-fv-col">
        <OrderEditForm
          embedded
          order={order}
          registerControls={setEditControls}
          onClose={onBack}
          onSaved={() => {
            onListChanged?.();
            showToast({ message: 'Pedido modificado.', variant: 'success' });
            onBack();
          }}
        />
      </div>
    </div>
  );
}
